import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

const CitasDoctor = () => {
  const { user } = useAuth();
  const [citas, setCitas] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [citasDelDia, setCitasDelDia] = useState([]);

  useEffect(() => {
    const fetchCitas = async () => {
      try {
        if (user?.id) {
          const res = await axios.get(`https://www.fancyplus.digital/api/medicos/citas/${user.id}`);
          setCitas(Array.isArray(res.data) ? res.data : []);
        }
      } catch (error) {
        console.error('Error al obtener citas:', error);
      }
    };

    fetchCitas();
  }, [user?.id]);

  const soloFecha = (fechaISO) => new Date(fechaISO).toISOString().split('T')[0];

  const onDateClick = (date) => {
    setSelectedDate(date);
    const fechaStr = date.toISOString().split('T')[0];
    const filtradas = citas.filter((c) => soloFecha(c.fecha) === fechaStr);
    setCitasDelDia(filtradas);
  };

  const citaPasada = (cita) => {
    const citaDateTime = new Date(`${soloFecha(cita.fecha)}T${cita.hora}`);
    return citaDateTime < new Date();
  };

  const fechaConCita = ({ date }) => {
    const fechaStr = date.toISOString().split('T')[0];
    return Array.isArray(citas) && citas.some((c) => soloFecha(c.fecha) === fechaStr)
      ? 'bg-green-100 border-2 border-green-500 rounded-xl relative'
      : 'rounded-xl';
  };

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const fechaStr = date.toISOString().split('T')[0];
      const citasFecha = citas.filter((c) => soloFecha(c.fecha) === fechaStr);

      if (citasFecha.length > 0) {
        const algunaPasada = citasFecha.some(citaPasada);
        return (
          <div className={`absolute top-1 right-1 ${algunaPasada ? 'text-red-600' : 'text-green-600'}`}>
            <FontAwesomeIcon icon={faClock} size="sm" />
          </div>
        );
      }
    }
    return null;
  };


  useEffect(() => {
    // Mostrar citas del día actual al cargar
    onDateClick(selectedDate);
  }, [citas]);

  return (
    <div className="p-6">
  <div className="backdrop-blur-md bg-white/30 shadow-md rounded-2xl p-6">
    <h2 className="text-4xl font-extrabold text-center text-blue-800 mb-8">
      Citas de mis pacientes
    </h2>

      <div className="grid grid-cols-3 gap-6">
        {/* Calendario */}
        <div className="flex col-span-1 scale-100">
          <div className="rounded-3xl overflow-hidden shadow-lg">
            <Calendar
              onClickDay={onDateClick}
              tileClassName={fechaConCita}
              tileContent={tileContent}
            />
          </div>
        </div>

      {/* Tabla de citas */}
      <div className="col-span-2 bg-white shadow-lg rounded-xl p-4 overflow-x-auto text-sm">
        <h3 className="text-xl font-bold mb-4">
          Citas del {selectedDate.toLocaleDateString()}
        </h3>

        {citasDelDia.length > 0 ? (
          <table className="min-w-full border">
            <thead>
              <tr className="bg-gray-100">
                <th className="border px-4 py-2">Paciente</th>
                <th className="border px-4 py-2">Email</th>
                <th className="border px-4 py-2">Edad</th>
                <th className="border px-4 py-2">Teléfono</th>
                <th className="border px-4 py-2">Tipo</th>
                <th className="border px-4 py-2">Síntomas</th>
                <th className="border px-4 py-2">Hora</th>
                <th className="border px-4 py-2">Estado</th>
              </tr>
            </thead>
            <tbody>
              {citasDelDia.map((cita) => (
                <tr key={cita.id_cita}>
                  <td className="border px-4 py-2">
                    {cita.name} {cita.apellidos}
                  </td>
                  <td className="border px-4 py-2">{cita.email}</td>
                  <td className="border px-4 py-2">{cita.edad || 'N/A'}</td>
                  <td className="border px-4 py-2">{cita.telefono || 'N/A'}</td>
                  <td className="border px-4 py-2">{cita.tipo}</td>
                  <td className="border px-4 py-2">{cita.sintomas}</td>
                  <td className="border px-4 py-2">{cita.hora}</td>
                  <td className="border px-4 py-2">{cita.estado}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No hay citas para este día.</p>
        )}
      </div>
    </div>
  </div>
</div>
  );
};

export default CitasDoctor;
